// extracted by mini-css-extract-plugin
export default {"dropzone-overlay":"FullscreenDropzone_dropzone-overlay__-J8jd"};